import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IFilterComponent, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { ServiceFilter } from 'src/app/model/service-filter';
import { PhysicianFilter } from 'src/app/model/physician-Filter';
import { EquipmentFilter } from 'src/app/model/equipment-filter';
import { Entity, Plan } from 'src/app/model/entity';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FilterService } from 'src/app/services/filter.service';
import { FilterRecordService } from 'src/app/services/filter-record.service';
import { ReservationService } from 'src/app/services/reservation.service';
import { PatientSearch } from 'src/app/model/patient';
import { CenterFilter } from '../../../model/center-filter';

@Component({
  selector: 'app-reservation-confirmation-filter',
  templateUrl: './reservation-confirmation-filter.component.html',
})
export class ReservationConfirmationtFilterComponent implements IFilterComponent, OnInit {

  @ViewChild('formElement', {static: false}) formElement: ElementRef;
  serviceFilters: ServiceFilter[] = [];
  centerFilters: CenterFilter[] = [];
  form: FormGroup;

  constructor(private formBuilder: FormBuilder
    , private filterService: FilterService
    , private filterRecordService: FilterRecordService
    , private reservationService: ReservationService) {

    this.form = this.formBuilder.group({
      DateFrom: [new Date(), [Validators.required]],
      DateTo: [new Date(), [Validators.required]],
      Patient: [null],
      Centers: [''],
      Services: [''],
      ViewCancel: [''],
    });
  }

  get f() { return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    requiredTags.push('DateFrom');
    requiredTags.push('DateTo');
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('ReservationConfirmationtFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('ReservationConfirmationtFilterComponent', this.form);
  }

  async search(): Promise<any> {
    const serviceIds = [];
    const centerIds = [];

    if (this.form.controls.Services.value) {
      this.form.controls.Services.value.forEach(element => {
        serviceIds.push(element.Id);
      });
    }

    if (this.form.controls.Centers.value) {
      this.form.controls.Centers.value.forEach(element => {
        centerIds.push(element.Id);
      });
    }

    return await this.reservationService.getReservationSearchItemsForConfirmation(
      this.form.controls.ViewCancel.value ? this.form.controls.ViewCancel.value : false
      , <Date>this.form.controls.DateFrom.value
      , <Date>this.form.controls.DateTo.value
      , serviceIds
      , centerIds
      , (this.form.controls.Patient.value ? (<PatientSearch>this.form.controls.Patient.value).Id : null));
  }

  async ngOnInit() {
    this.filterService.getCentersFilter().then((centers) => {
      this.centerFilters = centers;
    });

    this.filterService.getServicesFilter().then((services) => {
      this.serviceFilters = services;
    });
  }
}
